var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0763 1.45076C12.3106 1.21645 12.6905 1.21645 12.9249 1.45076L17.4249 5.95076C17.6592 6.18507 17.6592 6.56497 17.4249 6.79929C17.1905 7.0336 16.8106 7.0336 16.5763 6.79929L13.1004 3.32336V13.125C13.1004 13.4564 12.8318 13.725 12.5004 13.725C12.169 13.725 11.9004 13.4564 11.9004 13.125V3.32375L8.42485 6.79929C8.19054 7.0336 7.81064 7.0336 7.57632 6.79929C7.34201 6.56497 7.34201 6.18507 7.57632 5.95076L12.0763 1.45076ZM4.62539 11.35C4.33544 11.35 4.10039 11.5851 4.10039 11.875V21C4.10039 21.29 4.33544 21.525 4.62539 21.525H20.3754C20.6653 21.525 20.9004 21.29 20.9004 21V11.875C20.9004 11.5851 20.6653 11.35 20.3754 11.35H18.1254C17.794 11.35 17.5254 11.0814 17.5254 10.75C17.5254 10.4187 17.794 10.15 18.1254 10.15H20.3754C21.3281 10.15 22.1004 10.9223 22.1004 11.875V21C22.1004 21.9527 21.3281 22.725 20.3754 22.725H4.62539C3.6727 22.725 2.90039 21.9527 2.90039 21V11.875C2.90039 10.9223 3.6727 10.15 4.62539 10.15H6.87539C7.20676 10.15 7.47539 10.4187 7.47539 10.75C7.47539 11.0814 7.20676 11.35 6.87539 11.35H4.62539Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b88dbbfbda7d1514ee9a147b4628ce6e.svg";
export { ForwardRef as ReactComponent };